<template>

  <ModalContainer queryParam="msp" ref="modalContainer" size="xl">
    <b-card style="border: 1px solid #ccc;">
      <h4 class="text-center mb-2">Informacion de MSP</h4>


      <div class="d-flex justify-content-end align-text-bottom">
        <b-button 
          variant="outline-primary" 
          @click="redirectToMSP"
        >
          Solicitar MSP
        </b-button>
      </div>

      <div 
        v-for="titular in itemsToMsp" 
        :key="titular.id"
      >
        <LoadFileInput
          v-model="titular.newMsp"
          :label="titular.nombre"
          :urlFile="titular.urlMsp"
        />
        <hr>
      </div>

      <div class="d-flex justify-content-end">

        <b-button 
          variant="success"
          @click="onSaveMsp"
          :disabled="disabledButtonUpdate"
        >
          Guardar Cambios
        </b-button>
      </div>
    </b-card>
  </ModalContainer>
  
</template>

<script>
import { titularService, fileService } from '@/shared/services';
import { LoadFileInput, ModalContainer }  from '@/shared/components';
import { labAuxiliarService }  from '../services';
import { labAuxMapper } from "../helpers";

export default {
  name: "LoadMsp",
  components: {
    LoadFileInput,
    ModalContainer
  },

  created() {
    this.loadData();
  },

  data() {
    return {
      itemsToMsp: [],
      dataFilesToUpdate: null,
      tokenLab:  null,
      urlMspMap: null,
      metaData:{
        pacienteId     : null,
        nombrePaciente : null,
        proceso        : null
      }

    };
  },

  methods: {

    async loadData(){
      await this.loadDataLab();
      await this.lodaDataMsp();
    },

    redirectToMSP() {
      const url = "https://coberturasalud.msp.gob.ec/";
      window.open(url, "_blank");
    },
    async loadDataLab(){
      this.tokenLab = this.$route.query.msp;
      if(!this.tokenLab) return;
      const responselabs = await labAuxiliarService.getAll({ tokenLaboratorio: this.tokenLab });
      if(!responselabs) return;
      const responselab = responselabs.data[0];
      const dataPaciente = responselab.atencionMedica.cita.paciente;
      const dataCita = responselab.atencionMedica.cita;
      const dataLab  = responselab.laboratorios;
      //proceso        : `${dataLab.codigo} - ${dataLab.descripcion}`,
      
      labAuxMapper(responselab)
      const msppact = labAuxMapper(responselab);

      this.urlMspMap = {
        0: msppact.mspPaciente,
        1: msppact.mspTitular1,
        2: msppact.mspTitular2
      };

      this.metaData = {
        pacienteId     : dataPaciente.id,
        nombrePaciente : `${dataPaciente.persona.identificacion} - ${dataPaciente.persona.primerApellido} ${dataPaciente.persona.primerNombre}`,
        cita           : dataCita
      }
    },
    
    async lodaDataMsp(){
      if(!this.metaData.pacienteId) return;
      const responseTitulares = await titularService.getTitularesByIdCita(this.metaData.cita.id);
      let personasToMsp = []
      try{
        let titulares = JSON.parse(responseTitulares.titulares)
        if(titulares && titulares.length) {
          titulares.forEach(element => {
            if(element.nombres)
              personasToMsp.push(element.nombres)
            else if(element.nombre)
              personasToMsp.push(element.cedula + ' - ' + element.nombre);
          });
        }
       
      }catch(error){
        console.log("error parseo", error)
      }
      const nombresPaciente = `${responseTitulares.paciente.identificacion} - ${responseTitulares.paciente.primerApellido} ${responseTitulares.paciente.primerNombre}`
      personasToMsp.unshift(nombresPaciente)
      
      this.itemsToMsp = personasToMsp.map( (t, index) => {
        return{
          identificacion: t,
          nombre  : t,
          urlMsp  : this.urlMspMap[index],
          newMsp  : null,
          nTitular: index
        }
      });


      console.log(this.itemsToMsp);
    },
    prepararArchivosMsp(data){
      const mspPaciente = data.find( d => d.nTitular === 0 );
      const mspTitular1 = data.find( d => d.nTitular === 1 );
      const mspTitular2 = data.find( d => d.nTitular === 2 );
      const mspTitular3 = data.find( d => d.nTitular === 3 );

      this.dataFilesToUpdate = {
        mspPaciente: mspPaciente,
        mspTitular1: mspTitular1,
        mspTitular2: mspTitular2,
        mspTitular3: mspTitular3
      };

      this.$store.commit('setFiles', this.dataFilesToUpdate);
    },



    async onSaveMsp(){

      const response = await this.$swal({
        title: '¿Estas seguro?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, guardar!',
        cancelButtonText: 'Cancelar'
      });

      if (!response.isConfirmed) return;

      let urlMspPaciente = null;
      let urlMspTitular1 = null;
      let urlMspTitular2 = null;
      let urlMspTitular3 = null;

      const { mspPaciente, mspTitular1, mspTitular2, mspTitular3 } = this.dataFilesToUpdate;
      if(mspPaciente)
        urlMspPaciente = await fileService.upload('mspLaboratorios', mspPaciente.newMsp, mspPaciente.identificacion, mspPaciente.urlMsp);
      if(mspTitular1)
        urlMspTitular1 = await fileService.upload('mspLaboratorios', mspTitular1.newMsp, mspTitular1.identificacion, mspTitular1.urlMsp);
      if(mspTitular2)
        urlMspTitular2 = await fileService.upload('mspLaboratorios', mspTitular2.newMsp, mspTitular2.identificacion, mspTitular2.urlMsp);
      if(mspTitular3)
        urlMspTitular3 = await fileService.upload('mspLaboratorios', mspTitular3.newMsp, mspTitular3.identificacion, mspTitular3.urlMsp);
      
      const fieldsToUpdate = {
        urlMspCalificacion : urlMspPaciente,
        urlMspCalificacion1 : urlMspTitular1,
        urlMspCalificacion2 : urlMspTitular2
      };

      const responseUpdate = await  labAuxiliarService.updateByToken(this.tokenLab, fieldsToUpdate);

      if(!responseUpdate) {
        this.$swal({
          title: "Error al actualizar Msp",
          icon: "error",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "ok",
        });
        return;
      }

      await this.$swal({
        title: "Msp actualizado correctamente",
        icon: "success",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "ok",
      });
      this.itemsToMsp = [];
      this.$router.go(0);
    }
  },
  computed: {
    disabledButtonUpdate(){
      return !this.itemsToMsp.find( d => d.newMsp );
    }
  },

  watch:{
    itemsToMsp: {
      deep: true,
      immediate: true,
      handler(newValue){
        this.prepararArchivosMsp(newValue);
      }
    },

    '$route.query.msp': {
      handler(newValue){
        if(!newValue) return;
        this.loadData();
      }
    }
  }
}
</script>
